module.exports = __webpack_public_path__ + "img/icono-2inventario-min.64b0c5b3.png";